import React from 'react'
import { SvgIcon } from '../svg-icon.js'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {Object}
 */
const defaultProps = {
    viewBoxSize: 24
}

const AttachmentIcon = props => {
    return (
        <SvgIcon {...props}>
            <path
                d={`M17.75,17.5H13h-0.75H7c-3.02,0-5.5-2.47-5.5-5.5S3.98,6.5,7,6.5h5.5H13h6.5c2.2,0,4,1.8,4,4s-1.8,4-4,
            4H15h-2.5H9c-1.38,0-2.5-1.12-2.5-2.5S7.62,9.5,9,9.5h5.25H15h2.75c0.41,0,0.75,0.34,0.75,0.75S18.16,11,17.75,
            11h-0.46H15h-0.75H9c-0.55,0-1,0.45-1,1s0.45,1,1,1h0.41h3.09H15h2.29h2.21c1.38,0,2.5-1.12,2.5-2.5S20.88,
            8,19.5,8h-2.76H13h-0.5H9.41H7.5H7c-2.21,0-4,1.79-4,4s1.79,4,4,4h0.5h4.75H13h3.76h0.99c0.41,0,0.75,0.34,0.75,
            0.75S18.16,17.5,17.75,17.5z`}
            />
        </SvgIcon>
    )
}

AttachmentIcon.defaultProps = defaultProps

export { AttachmentIcon }
